module.exports = __webpack_public_path__ + "img/ic_check.88c852af.svg";